import { render, staticRenderFns } from "./formDesignRules.vue?vue&type=template&id=2d144f20&scoped=true&"
import script from "./formDesignRules.vue?vue&type=script&lang=js&"
export * from "./formDesignRules.vue?vue&type=script&lang=js&"
import style0 from "./formDesignRules.vue?vue&type=style&index=0&id=2d144f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d144f20",
  null
  
)

export default component.exports